import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const WarnAlert = forwardRef<SVGSVGElement, SvgIconProps>(
  function WarnAlert(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m12.411567,1.029505c0.146075,0.079413 0.266055,0.199392 0.345484,0.345484l11.105926,20.426907c0.227344,0.418139 0.072655,0.941413 -0.345484,1.168757c-0.126329,0.068688 -0.267842,0.104675 -0.411653,0.104675l-22.211851,0c-0.47595,0 -0.861796,-0.385846 -0.861796,-0.861796c0,-0.143794 0.035987,-0.285308 0.104675,-0.411636l11.105926,-20.426907c0.227344,-0.418156 0.750618,-0.572828 1.168774,-0.345484zm-0.411653,16.61502c-0.670933,0 -1.215026,0.564811 -1.215026,1.261772c0,0.696536 0.544093,1.261397 1.215026,1.261397c0.67095,0 1.215043,-0.564913 1.215043,-1.261397c0,-0.69691 -0.544093,-1.261772 -1.215043,-1.261772zm0.057862,-10.897767c-1.138609,0 -2.061808,0.795883 -2.061808,1.777453l0,0l1.427066,6.152517l0.046405,0.127299c0.23989,0.466774 1.094162,0.424336 1.222346,-0.127299l0,0l1.427815,-6.152517l-0.012103,-0.193655c-0.111944,-0.890463 -0.987018,-1.583798 -2.049721,-1.583798z" />
      </SvgIcon>
    )
  },
)

export default WarnAlert
